import state from '@/store/modules/Notification/state'
import getters from '@/store/modules/Notification/getters'
import mutations from '@/store/modules/Notification/mutations'
import actions from '@/store/modules/Notification/actions'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
